<!--  / eslint-disable no-new / --> 
<template>
  <div
    :class="[
      'run-code-content',
      'training-area-right',
      { 'training-area-right-off': !sidebarSwitch },
    ]"
  >
    <!-- 运行工具edit-tool -->
    <div :class="['edit-tool', { 'edit-tool-off': !workspaceIsVisible }]">
      <el-button class="btn-undo-redo" title="撤销" @click="undoHandle">
        <icon-base
          class="icon-undo-redo icon-undo"
          :icon-name="Icons.UndoOrRedo.undo"
          v-bind="Icons.UndoOrRedo.data"
        >
          <icon-undo-or-redo />
        </icon-base>
      </el-button>
      <el-button class="btn-redo-redo" title="重做" @click="redoHandle">
        <icon-base
          class="icon-undo-redo icon-redo"
          :icon-name="Icons.UndoOrRedo.redo"
          v-bind="Icons.UndoOrRedo.data"
        >
          <icon-undo-or-redo />
        </icon-base>
      </el-button>
      <el-button title="整理" @click="resetSvg">
        <icon-base
          class="icon-undo-redo icon-redo"
          :icon-name="Icons.DeskToday.iconName"
          v-bind="Icons.DeskToday"
        >
          <icon-desk-today />
        </icon-base>
      </el-button>
    </div>
    <div class="run-head">
      <div v-show="false" class="title">数据运算</div>
      <el-button @click="codeRunHandle" v-show="sidebarSwitch">
        <icon-base
          id="button_run"
          class="icon-code-run"
          :icon-base="Icons.CodeRun.iconName"
          v-bind="Icons.CodeRun"
        >
          <icon-code-run />
        </icon-base>
        运行
      </el-button>
      <el-button @click="clearWorkspace" v-show="sidebarSwitch">
        <icon-base
          class="icon-code-clear"
          :icon-base="Icons.CodeClear.iconName"
          v-bind="Icons.CodeClear"
        >
          <icon-code-clear />
        </icon-base>
        清除
      </el-button>

      <el-button
        v-show="sidebarSwitch && ifCreateBlock"
        @click="confirmNewBlock"
        :class="[!ifCreateBlock ? 'none-click' : '']"
        :style="{ 'pointer-events': ifCreateBlock ? 'auto' : 'none' }"
      >
        确定建积木
      </el-button>
      <el-button
        :class="{ 'sibebar-switch-off': !sidebarSwitch }"
        @click="sidebarSwitchHandle"
      >
        <icon-base
          class="icon-sibebar-switch"
          :icon-name="Icons.SidebarSwitch.iconName"
          v-bind="Icons.SidebarSwitch"
        >
          <icon-sibebar-switch />
        </icon-base>
      </el-button>
    </div>
    <!-- 代码运行结果模块 -->
    <div class="run-result">
      <div
        id="runMsgSuccess"
        :class="['run-msg-success', { 'run-msg-hide': !runStasus }]"
      >
        <i class="icon_box" v-show="runStasus === 'success'">
          <icon-base
            class="icon-run-success"
            :icon-name="Icons.RunSuccess.iconName"
            v-bind="Icons.RunSuccess"
          >
            <icon-run-success />
          </icon-base>
        </i>
        {{ Message.runCode[runStasus] }}
        <span class="error-btn" v-show="runStasus == 'fail'" @click="showError"
          >报错信息>
        </span>
        <p class="error-info" v-show="errorStatus">
          {{ errorText | filterErrorText }}
        </p>
      </div>

      <div
        id="runMsgCmd"
        class="run-msg-cmd"
        v-for="(item, index) of codeResult"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <!--分区 显示区域数组 -->
    <div
      :class="['run-ai', { 'run-ai-full-screen': isFullScreen }]"
      ref="runAi"
    >
      <!-- 头部 -->
      <div class="run-ai-head">
        <!-- <span class="title ellipsis">{{
          Train.trainingName || Project.projectName
        }}</span> -->
        <tooltip-box
          class="title"
          :textRef="'trainingNametips'"
          :textId="'123456'"
          :textRow="1"
          :textName="Train.trainingName || Project.projectName"
          :placement="'top'"
          :tooltipShow="false"
        ></tooltip-box>
        <el-button
          class="full-screen"
          :title="
            isFullScreen
              ? Icons.ExitFullScreen.iconName
              : Icons.FullScreen.iconName
          "
          @click="fullScreen"
        >
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.FullScreen.iconName"
            v-bind="Icons.FullScreen"
            v-show="!isFullScreen"
          >
            <icon-full-screen />
          </icon-base>
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.ExitFullScreen.iconName"
            v-bind="Icons.ExitFullScreen"
            v-show="isFullScreen"
          >
            <icon-exit-full-screen />
          </icon-base>
        </el-button>
      </div>
      <!-- 分区显示 -->
      <!--判断：当有标题时，不显示背景 -->
      <div
        v-for="(item, index) in partNum"
        :key="item"
        :class="[
          'run-ai-area',
          {
            'run-ai-area-bg-remove':
              runStasus == 'success' || runStasus == 'loading',
          },
        ]"
        :style="{
          width: partWidth ? partWidth + 'px' : '100%',
          height: partHeight ? partHeight + 'px' : '100%',
          float: 'left',
          'background-size':
            partNum == 1 ? '' : partNum == 4 ? '38% 70%' : '40% 50%',
        }"
      >
        <span class="title-wrap">
          <span class="title-label">{{ index + 1 }}</span>
          <span class="title-text">{{ partNumTitleArr[index] }}</span>
        </span>
        <!-- 文本显示 -->
        <div
          :class="['run-ai-area-msg', {'run-ai-area-msg-four': partNum == 4}, {'run-ai-area-msg-nine': partNum == 9}]"
          v-if="
            partNumArr[index] &&
              partNumArr[index].msgRunResult &&
              (partNumArr[index].msgRunResult.length ||
                partNumArr[index].textUrl.length)
          "
        >
          <div
            class="msg-wrap"
            v-if="
              partNumArr[index] &&
                partNumArr[index].msgRunResult &&
                partNumArr[index].msgRunResult.length
            "
          >
            <p
              v-for="(item2, idx) in partNumArr[index].msgRunResult"
              :key="idx"
            >
              {{ item2 }}
            </p>
          </div>
          <!-- 文本文件的显示  -->
          <div
            class="txt-file-content"
            v-for="(item3, idx) in partNumArr[index].textUrl"
            :key="idx"
            v-html="item3"
          ></div>
        </div>
        <!-- 图片显示-->
        <div
          class="run-ai-area-pic"
          v-if="partNumArr[index] && partNumArr[index].src"
        >
          <img
            v-for="(imgItem, subIndex) of partNumArr[index].imgArr"
            :key="subIndex"
            :src="imgItem.src"
            :style="{
              width: `${100 / partNumArr[index].imgLength}%`,
              transform: `scale(${imgItem.size})`,
            }"
            alt
          />
        </div>
        <!-- <img :src="showPic.src" :style="{ width: showPic.size, height: showPic.size }" alt /> -->
        <!-- 音频文件显示   v-if="audioList[index] && audioList[index].url"-->

        <gta-audio
          :audioItem="audioList[index]"
          :audioIndex="index"
          v-if="audioList[index] && audioList[index].url"
        />
        <!-- 摄像头显示 -->
        <div
          class=" run-ai-area-media"
          id="divvideo1"
          v-if="mediaArr.length > 0 && mediaArr[index]"
        >
          <img
            id="bg"
            :src="mediaArr[index].MediaFileUrl"
            :style="{
              width: mediaWidth || '100%',
              height: mediaHeight || '100%',
            }"
            alt
          />
          <!-- style="width:960px;height:540px;" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import RUN from '@/axios/pythonRun/run.js'
import gtaAudio from '@/components/common/Audio'
import { mapGetters } from 'vuex'
// 图标
import IconUndoOrRedo from '@/components/icons/typography/UndoOrRedo'
import IconDeskToday from '@/components/icons/typography/DeskToday'
import IconSibebarSwitch from '@/components/icons/typography/SidebarSwitch'
import IconCodeRun from '@/components/icons/typography/CodeRun'
import IconCodeClear from '@/components/icons/typography/CodeClear'
import IconRunSuccess from '@/components/icons/typography/RunSuccess'
import IconFullScreen from '@/components/icons/typography/FullScreen'
import IconExitFullScreen from '@/components/icons/typography/ExitFullScreen'
import TooltipBox from '@/components/common/TooltipBox'
//公共方法
import bus from '@/utils/bus'
import util from '@/utils/index.js'
import { showFaceApiDom, showBodyApiDom, showHandApiDom } from './AiFunc.js'
import { GetText } from '@/assets/js/mixin/mixinGetTextStr.js'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    gtaAudio,
    IconUndoOrRedo,
    IconDeskToday,
    IconSibebarSwitch,
    IconCodeRun,
    IconCodeClear,
    IconRunSuccess,
    IconFullScreen,
    IconExitFullScreen,
    TooltipBox
  },
  mixins: [GetText],
  props: {
    // 运行结果
    codeText: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
    projectId: {
      type: String,
      default: null,
    },
    // xml 保存相关数据
    Project: {
      type: Object,
      default: () => {
        return {}
      },
    },
    workspaceIsVisible: {
      type: Boolean,
      default: true,
    },
    // toolShow: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  data() {
    return {
      runResult: {},
      errorMsg: null, //错误信息
      errorText: null, //错误信息
      errorStatus: false,
      sidebarSwitch: true,
      hasRunSuccess: false,
      ifCreateBlock: false,
      runStasus: null,
      running: null, //运行区请求的状态，true表示正在请求
      codeResult: [],
      aiBlockResult: {}, //智能积木对象
      partNumTitleArr: ['标题'], //存放无人小车功能解析的参数
      gtaFunDriveArr: [], //储存各个分区标题
      hasMediaAttr: false,
      partNumArr: [{ imgArr: [] }], //显示区内容
      mediaArr: [], //摄像头数组
      aiBlockArr: [], //摄像头显示的功能
      audioList: [], //音频功能数组
      codeTextResult: '',
      isFullScreen: false,
      isMeida: null, //是否存在摄像头
      partNum: 1,
      isPart: false, //工作区积木是否有分区积木;
      partIndex: 1, //分区索引
      partWidth: null,
      partHeight: null,
      mediaWidth: null,
      mediaHeight: null,
      offsetWidth: null,
      MediaOffsetTop: null, //摄像头上偏移距离
      MediaOffsetLeft: null, //摄像头左偏移距离
      beMark: false, //遮罩层
      mediaDomain: window.gtaAiConfig.netCameraObj.host,
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 文件资源地址（代理）
      fileBaseUrl: window.gtaAiConfig.fileBaseUrl, // 文件资源地址
      Message: {
        runCode: {
          loading: '正在运行中...',
          fail: '运行失败！',
          success: '运行成功！',
          noText: '没有运行的脚本！',
        },
      },

      Icons: {
        NavFile: {
          iconName: '文件',
          viewBox: '0 0 19 18',
          width: '19',
          height: '18',
          iconColor: '#fff',
        },
        NavSave: {
          iconName: '保存',
          viewBox: '0 0 18 19',
          width: '18',
          height: '19',
          iconColor: '#fff',
        },
        ModeCode: {
          iconName: '代码模式',
          viewBox: '0 0 16 15',
          width: '16',
          height: '15',
          iconColor: '#5883ff',
        },
        HeadHelp: {
          iconName: '使用文档',
          viewBox: '0 0 24 24',
          width: '24',
          height: '24',
          iconColor: '#fff',
        },
        // 撤销或重做
        UndoOrRedo: {
          undo: '撤销',
          redo: '重做',
          data: {
            // iconName: "撤销或重做",
            viewBox: '0 0 18 15',
            width: '18',
            height: '15',
          },
        },
        // 桌面整理
        DeskToday: {
          iconName: '整理',
          viewBox: '0 0 17 13',
          width: '17',
          height: '13',
        },
        SidebarSwitch: {
          iconName: '收起',
          viewBox: '0 0 13 14',
          width: '13',
          height: '14',
        },
        CodeRun: {
          iconName: '运行',
          viewBox: '0 0 16 16',
          width: '16',
          height: '16',
        },
        CodeClear: {
          iconName: '清除',
          viewBox: '0 0 16.03 15',
          width: '16.03',
          height: '15',
        },
        RunSuccess: {
          iconName: '运行成功',
          viewBox: '0 0 16 16',
          width: '16',
          height: '16',
        },
        FullScreen: {
          iconName: '全屏',
          viewBox: '0 0 19 19',
          width: '19',
          height: '19',
        },
        ExitFullScreen: {
          iconName: '退出全屏',
          viewBox: '0 0 21 21',
          width: '21',
          height: '21',
        },
        createBlockTextLength: 0, //创建积木脚本长度
        newBlockPythonCode: '', //创建积木脚本长度
      },
    }
  },
  filters: {
    filterErrorText(text) {
      let reg_line = /(", line )+[\d]/gi
      console.log('text', text)
      if (text) {
        text = text.replace(reg_line, '')
      }

      return text
    },
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['Train']),
  },
  //监控data中的数据变化
  watch: {
    //对运行结果进行集中处理
    runResult(newVal) {
      if (newVal && newVal.cmdstr) {
        let msg = JSON.parse(JSON.stringify(newVal.msg)),
          cmdstr = JSON.parse(JSON.stringify(newVal.cmdstr))

        //运行区的文本解析
        if (cmdstr && cmdstr.length) {
          this.runResultToDom(cmdstr)
        }

        //显示区的解析
        if (msg && msg.length) {
          this.printToDom(msg)
        }
      }
    },
    errorMsg(val) {
      if (val && typeof val == 'string') {
        this.errorText = val
      } else if (val && typeof val == 'object') {
        val.forEach((obj) => {
          let values = Object.values(obj)
          if (values.length > 0) {
            values.forEach((arr) => {
              if (Array.isArray(arr)) {
                let text = arr.join(';') // arr
                this.errorText += text
              }
            })
          }
        })
      } else {
        this.errorText = null
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var self = this
    this.$nextTick(() => {
      self.getHeightWidth(self.partNum)
    })
    bus.$on('codeRunHandle', () => {
      self.codeRunHandle()
    })
  },
  beforeDestroy() {
    bus.$off('codeRunHandle')
  },
  methods: {
    showError() {
      this.errorStatus = !this.errorStatus
      console.log('this.errorStatus', this.errorStatus)
    },
    undoHandle() {
      var undoDom = document.getElementById('btnUndo')
      if (undoDom) {
        undoDom.click()
      }
    },
    redoHandle() {
      var redoDom = document.getElementById('btnRedo')
      if (redoDom) {
        redoDom.click()
      }
    },
    resetSvg() {
      var resetSvgDom = document.getElementById('btnResetSvg')
      if (resetSvgDom) {
        resetSvgDom.click()
      }
    },

    //从文本路径中获取到文本内容
    async getTextFromUrl(partIndex, textUrl) {
      await this.getTxtContent(textUrl)
      setTimeout(() => {
        if (!this.textStatus) {
          this.$message.error('文档内容过少，无法读取文档内容')
          this.partNumArr[partIndex - 1].textUrl = ''
        } else {
          this.partNumArr[partIndex - 1].textUrl.push(this.getTextStr)
          this.$forceUpdate()
        }
      }, 1000)
    },
    /**
      *
      *
     以下为运行前对python脚本解析的方法
     **/
    //分区的宽高
    getHeightWidth(partNum) {
      var self = this
      setTimeout(() => {
        var runAi = this.$refs.runAi,
          // var runAi = document.getElementsByClassName("run-ai")[0],
          partWidth,
          partHeight
        var offsetWidth = runAi.offsetWidth
        var offsetHeight = runAi.offsetHeight
        if (partNum == 4) {
          partWidth = (offsetWidth / partNum) * 2
          partHeight = ((offsetHeight - 40) / partNum) * 2
        } else if (partNum == 9) {
          partWidth = (offsetWidth / partNum) * 3
          partHeight = ((offsetHeight - 40) / partNum) * 3
        } else {
          partWidth = offsetWidth
          partHeight = offsetHeight - 40
        }
        self.offsetWidth = offsetWidth
        self.offsetHeight = offsetHeight
        self.partWidth = partWidth - 2.5 //宽度减少5像素
        self.partHeight = partHeight

        // 摄像头积木的宽高
        var tempWidth = (partWidth * 9) / 16
        // debugger;
        if (tempWidth < partHeight) {
          //非全屏
          this.mediaWidth = partWidth //宽度减少5像素
          this.mediaHeight = ((partWidth * 9) / 16).toFixed(0)
          this.MediaOffsetTop = Math.ceil((partHeight - this.mediaHeight) / 2)
          this.MediaOffsetLeft = 0
        } else {
          //全屏
          this.mediaHeight = partHeight
          this.mediaWidth = ((partHeight * 16) / 9).toFixed(0) //宽度减少5像素
          this.MediaOffsetTop = 0
          this.MediaOffsetLeft = Math.ceil((partWidth - this.mediaWidth) / 2)
        }
      }, 100)
    },

    //运行积木代码
    async codeRunHandle() {
      //在一个请求结束前禁止再次请求
      if (this.running) {
        return
      }
      //运行前初始化
      this.runStasus = null
      this.errorStatus = false

      //代码运行结果
      var self = this
      self.codeResult = [] //清空运行区缓存
      self.audioList = [] //清空音频缓存
      await this.$emit('runHandle') //直接调用父组件，间接调用BlocklyEditer.vue组件

      let codeText = this.$store.state.blocklyHome.codeText
      codeText = codeText.replace('/service_photoDomain', this.fileBaseUrl)
      console.log('codeText1\n == ', codeText)

      if (!this.runStasus && codeText) {
        this.runStasus = 'loading'
      } else if (!codeText) {
        this.runStasus = 'noText'
      }
      if (codeText) {
        //代码运行进行分区运行
        let status = await this.runPart(codeText)
        if (status === false) return
        //创建积木步骤2  运行积木脚本成功后并分离创建积木的脚本
        this.splitCreateBlockCode()

        // 执行python后台接口
        let res = await this.runCode()
        return res
      }
    },

    // 积木代码分区运行
    runPart(codeText) {
      this.codeTextResult = '' //清空前一次的数据
      var isPart = codeText.indexOf('partNum'),
        isPartIndex = codeText.indexOf('def part'),
        hasGuoliRobot = new RegExp('robot = Robot("robot")').test(codeText),
        partFuncStr, //函数字符串
        partFunc,
        AllPartFunc = '',
        reg_n = /(\s)+(\n)/g, //去掉空行
        partIndex,
        partNum
      // 分区数目
      if (isPart == -1) {
        //没有进行分区时默认一个分区
        codeText = 'def part1():' + '\n' + codeText
        partNum = 1
        this.isPart = false //判断是否有分区积木
      } else {
        partNum = codeText.substr(isPart, 10)
        partNum = Number(partNum.replace('partNum=', ''))
        this.isPart = true
        //没有运行分区结果时
        if (isPartIndex == -1) {
          codeText = 'def part1():' + '\n' + codeText
        }
      }
      this.mediaArr = new Array(partNum)
      this.partNumArr = new Array(partNum) //存放各个分区内容
      this.partNumTitleArr = new Array(partNum) //存放各个分区标题
      this.gtaFunDriveArr = new Array(partNum) //存放无人小车功能解析的参数
      this.audioList = new Array(partNum) //存放无人小车功能解析的参数
      for (let i = 0; i < partNum; i++) {
        this.partNumTitleArr[i] = '标题'
        this.gtaFunDriveArr[i] = [{}]
        this.gtaFunDriveArr[i][0].recording = null
        this.gtaFunDriveArr[i][0].throttle = null
        this.gtaFunDriveArr[i][0].angle = null
        this.gtaFunDriveArr[i][0].speed = null
        this.gtaFunDriveArr[i][0].url = null

        this.partNumArr[i] = {}
        this.partNumArr[i].msgRunResult = [] //存储需要显示的文本
        this.partNumArr[i].textUrl = [] //存储需要显示的文本路径
        this.partNumArr[i].src = null //存储需要显示的图片
        this.partNumArr[i].imgArr = [] //存储需要显示的图片数组
        this.partNumArr[i].aiBlockArr = [] //存储需要显示的积木
        this.partNumArr[i].aiHandBlockText = '' //存储手势识别方法需要显示的积木
        this.partNumArr[i].aiFuncArr = [] //存储需要调用的人工智能方法
      }

      this.partNum = partNum
      //可以获取宽高
      if (partNum) {
        this.getHeightWidth(partNum)
      }
      // 存在分区结果积木时对显示内容进行分区切割;
      var reg = /def part(\S*)?=\(/g,
        reg_3 = /(.*)\n/g, //匹配换行
        reg_time = /time.sleep/g, //判断是否有时间函数
        getIndex = codeText.indexOf('def part'),
        partIndexArr = [] //字符串分区索引

      while (codeText.indexOf('def part', getIndex) != -1) {
        //获取第几组分区显示
        getIndex = codeText.indexOf('def part', getIndex)
        partIndexArr.push(getIndex)
        getIndex = getIndex + 1
      }

      for (var i = 0, len = partIndexArr.length; i <= len; i++) {
        var getCodeText,
          getCodeTextArr = [], //代码换行处理
          newCodeText = '' //代码换行处理得到的文本
        /**partIndexArr[i] ==0 表示没有全局变量*/
        if (i == 0 && partIndexArr[i] != 0) {
          getCodeText = codeText.slice(0, partIndexArr[i])
          if (!getCodeText) {
            continue
          }
          if (/GTAPrint\(/g.test(getCodeText)) {
            this.$message.error('错误：全局变量区域不能有“显示”类型积木！')
            return false
          }
          this.codeTextResult = getCodeText
        } else {
          /**对每个分区脚本的处理*/

          getCodeText = codeText.slice(partIndexArr[i - 1], partIndexArr[i])
          if (!getCodeText) {
            continue
          }
          partFuncStr = codeText.substr(partIndexArr[i - 1], 9)
          partIndex = Number(partFuncStr.replace('def part', ''))

          if (partIndex > partNum) {
            this.$message({
              message: '选择分区不能大于分区总数',
              type: 'error',
              duration: 2000,
            })
            return
          }

          partFunc = partFuncStr.replace('def', '').trim() + '()\n'
          AllPartFunc = AllPartFunc.concat(partFunc)
          getCodeTextArr = getCodeText.match(reg_3) //匹配换行
          //将分区带有"def part"置于getCodeTextArr第一个元素上
          if (!/def part/.test(getCodeTextArr[0])) {
            getCodeTextArr.findIndex((text, index, arr) => {
              if (/def part/.test(text)) {
                arr.splice(index, 1)
                arr.unshift(text)
              }
            })
          }

          for (var j = 0, length = getCodeTextArr.length; j < length; j++) {
            if (j == 0) {
              newCodeText = getCodeTextArr[j]
              // 在每个分区函数的第一行脚本加入打印标识,print("PART_num")
              newCodeText =
                newCodeText + '    print("PART_' + partIndex + '")' + '\n'
              if (reg_time.test(getCodeText)) {
                //如果有时间函数，导入时间
                newCodeText = newCodeText + '    import time' + '\n'
              }
            } else {
              //对每行python脚本加处理，比如对每行增加4个空格和删除多余小括号等
              newCodeText =
                newCodeText +
                this.exchangePythonCode(getCodeTextArr[j], partIndex)
            }
          }
        }
        this.codeTextResult = this.codeTextResult + newCodeText //拼接字符串
      } //for end
      this.codeTextResult = this.codeTextResult + AllPartFunc //拼接总字符串

      //给包含果力机器人的代码设置gbk字符编码;
      if (hasGuoliRobot) {
        // console.log('hasGuoliRobot',hasGuoliRobot)
        this.codeTextResult =
          '# -*- coding: gbk -*-\nfrom robot import Robot\n' +
          this.codeTextResult
      }
    },
    // 每行python脚本处理： 转换方法，每行增加4个空格和删除多余小括号等对每行python脚本加处理
    exchangePythonCode(str, partIndex) {
      let reg_1 = /GTAPrint\(/,
        reg_2 = /\(/g,
        reg_3 = /\)/g,
        reg_attr = /attribute=/g,
        reg_http = /http/g,
        reg_s = /\s+/g,
        reg_img = /(?<=(jpg|gif|png|bmp|jpeg)('|"))(.$)/g,
        // reg_img = /(?<=(jpg|gif|png|bmp|jpeg)('|"))(.*)/g,
        reg_title = /partName/g,
        reg_drive = /GTAFunDrive/g,
        reg_create_block = /CREATEBLOCK/g,
        firstIndex = str.indexOf(')'),
        strArr,
        mediaWidth = this.mediaWidth,
        mediaHeight = this.mediaHeight,
        lastIndex = str.lastIndexOf('('),
        index_width = str.indexOf('width='),
        index_height = str.indexOf('height='),
        hasMedia = reg_1.test(str),
        Match = str.match(reg_2)

      // 删除多余的()小括号
      if (reg_1.test(str) && reg_attr.test(str)) {
        if (str.match(reg_2).length > 1) {
          strArr = str.split('')
          strArr.splice(firstIndex, 1)
          strArr.splice(lastIndex, 1)
          str = strArr.join('')
        }

        let resWidth = eval(mediaWidth).toFixed(0)
        let resHeigth = eval(mediaHeight).toFixed(0)
        //width,height值为NaN时的处理
        if (window.isNaN(resWidth) && !window.isNaN(resHeigth)) {
          resWidth = resHeigth
        }
        if (!window.isNaN(resWidth) && window.isNaN(resHeigth)) {
          resHeigth = resWidth
        }
        if (index_width > -1 && index_height > -1) {
          // 给显示的摄像头添加宽高参数值
          index_width = str.indexOf('width=') //必须重新获取width索引
          str =
            str.slice(0, index_width + 6) +
            "'" +
            resWidth +
            "'" +
            str.slice(index_width + 6)
          index_height = str.indexOf('height=') //必须重新获取height索引
          str =
            str.slice(0, index_height + 7) +
            "'" +
            resHeigth +
            "'" +
            str.slice(index_height + 7)
        }
      }

      // 去掉...
      // ...的括号(...)分情况是否去掉
      let reg_ellipsis_1 = /(?<=\,)\(\.{3}\)/g
      let reg_ellipsis_2 = /\(\.{3}\)(?=\,)/g

      if (reg_ellipsis_1.test(str) || reg_ellipsis_2.test(str)) {
        let reg_ellipsis_3 = /\(\.{3}\)/g //去掉(...)
        str = str.replace(reg_ellipsis_3, '')
      } else {
        let reg_ellipsis_4 = /(?<=\()\.{3}(?=\))/g //去掉...
        str = str.replace(reg_ellipsis_4, '')
      }

      //获取并解析摄像头积木信息
      this.getMediaInfo(str, partIndex)

      //获取并解析无人小车积木信息
      if (reg_drive.test(str)) {
        str = this.getDriveInfo(str, partIndex)
      }

      //图片路径后面奇怪符号的处理
      if (reg_http.test(str) && !reg_3.test(str)) {
        str = str.replace(reg_img, '')
        // str = str.replace(reg_s, '') + '\n'
      }

      //获取标题积木的信息并修改
      if (reg_title.test(str)) {
        this.getTitleInfo(str, partIndex)
      }

      // 获取新建积木的标志和脚本;
      if (reg_create_block.test(str)) {
        str = this.getCreateBlockInfo(str, partIndex)
      }

      str = '    ' + str //增加4个空格
      return str
    },
    // 获取并解析摄像头积木信息
    getMediaInfo(codeText, partIndex) {
      var self = this,
        mediaPath,
        mediaObj = {},
        textArr = codeText.split(','),
        reg_attr = /attribute=/,
        reg_func = /function=/,
        indexCam,
        MediaFileUrl,
        len = textArr.length,
        hasRtsp
      if (!len) return
      // indexCam = textArr[0].indexOf('rtsp://')
       indexCam = textArr[0].search(/(rtsp|rtmp):/)
      if (indexCam == -1) {
        indexCam = textArr[0].search(/(http:\/\/.*.m3u8)/)
      }
      if (indexCam > -1) {
        MediaFileUrl = textArr[0].slice(indexCam)
        MediaFileUrl = MediaFileUrl.slice(0, MediaFileUrl.length - 1)
        MediaFileUrl = MediaFileUrl.replace(/\)/g, '')
          .replace(/\(/g, '')
          .replace(/\"|\'/g, '')

        mediaPath = this.mediaDomain + MediaFileUrl //拼接路径
        mediaObj.MediaFileUrl = mediaPath
        mediaObj.partIndex = partIndex

        this.mediaArr[partIndex - 1] = {}
        this.mediaArr[partIndex - 1] = mediaObj //摄像头地址需要重新分配
        console.log('this.mediaArr', this.mediaArr)
        // 获取分区积木
        textArr.find((item) => {
          if (reg_attr.test(item)) {
            var aiBlock = item.replace(reg_attr, '')
            var aiFunc = item.replace(reg_func, '')
            self.partNumArr[partIndex - 1].aiBlockArr.push(aiBlock)
            self.partNumArr[partIndex - 1].aiFuncArr.push(aiFunc)
          }
        })
      }
    },
    /**
      *
      *
     python代码运行接口
     **/
    runCode() {
      // 处理后的文本
      var self = this
      var codeTextResult = this.codeTextResult
      codeTextResult = codeTextResult.replace(/\/service_photoDomain/g, this.fileBaseUrl);
      console.log('codeTextResult\n', codeTextResult)
      this.running = true //表示正在运行请求，
      this.$store.commit('setPythonRunning', true)
      return RUN.RunCode(codeTextResult)
        .then((result) => {
          self.runStasus = result.isSuccess ? 'success' : 'fail'
          self.running = false //表示运行请求结束
          this.$store.commit('setPythonRunning', false)
          if (result.isSuccess) {
            this.runResult = result.data
            this.hasRunSuccess = true //表示运行成功
            self.errorText = null
            this.$store.state.blocklyHome.hasRunSuccess = true //全局变量
            self.partNumArr.find((item) => {
              if (item.aiBlockArr && item.aiBlockArr.length > 0) {
                self.hasMediaAttr = true
              }
            })
            if (self.hasMediaAttr) {
              self.codeRunHandle() //反复请求
            }
            this.errorMsg = null
          } else {
            this.hasRunSuccess = false //表示运行失败
            this.$store.state.blocklyHome.hasRunSuccess = false //全局变量
            this.errorMsg = result.errorMsg
            console.log('errorMsg', result.errorMsg)
          }
          return result
        })
        .catch((err) => {
          console.log(err)
          self.running = false //表示运行请求结束
          self.runStasus = 'fail'
        })
    },

    /**
      *
      *
     python代码运行后的解析方法
     **/
    //运行区：文本解析
    runResultToDom(cmdstr) {
      for (let i = 0, len = cmdstr.length; i < len; i++) {
        let valuesArr, valuesStr
        if (typeof cmdstr[i] == 'string') {
          valuesStr = cmdstr[i]
          this.codeResult.push(valuesStr)
        } else {
          valuesArr = Object.values(cmdstr[i])[0]
          if (valuesArr && valuesArr.length) {
            this.CodeSetInterval(valuesArr)
          }
        }
      }
    },
    //运行区：间隔多少时间显示的计时器
    CodeSetInterval(valuesArr) {
      let newArr
      for (let i = 0, len = valuesArr.length; i < len; i++) {
        if (!valuesArr[i] || valuesArr[i] == '') continue
        if (
          typeof valuesArr[i] == 'object' &&
          valuesArr[i].funstr &&
          valuesArr[i].funstr == 'GTAFunWait'
        ) {
          try {
            let getTime = valuesArr[i].decstr
            getTime = eval(getTime) * 1000
            newArr = valuesArr.splice(i + 1)

            setTimeout(() => {
              this.CodeSetInterval(newArr)
            }, getTime)
            break
          } catch (e) {
            console.log(e)
          }
        } else if (typeof valuesArr[i] == 'string') {
          this.codeResult.push(valuesArr[i])
        }
      }
    },

    //显示区：解析
    printToDom(msg) {
      let key,
        valuesArr,
        partIndex,
        reg_part = /PART_/g
      for (var i = 0, len = msg.length; i < len; i++) {
        key = Object.keys(msg[i])[0]
        // 解析key
        partIndex = key.replace(reg_part, '')
        valuesArr = Object.values(msg[i])[0]
        this.printSetInterval(valuesArr, partIndex)
      } //for i end
    },

    //显示区间隔多少时间显示的计时器  分类解析不同的功能
    printSetInterval(valuesArr, partIndex) {
      valuesArr.forEach(item => {
        item.decstr = item.decstr.replace('/service_photoDomain', this.fileBaseUrl)
      });
      let newArr,
        getTime,
        reg_6 = /{/g,
        reg_7 = /}/g,
        reg_img = /^(\s|\S)+(jpg|gif|png|bmp|jpeg|.m3u8)/i,
        reg_rtsp = /(rtsp|rtmp):/,
        reg_text_url = /^^((http|https):\/\/).*(.txt)/i
      for (let j = 0, len = valuesArr.length; j < len; j++) {
        var hasImg = reg_img.test(valuesArr[j].decstr)
        var hasCamera = reg_rtsp.test(valuesArr[j].decstr)
        // console.log('hasImg',hasImg);
        var hasTextFile = reg_text_url.test(valuesArr[j].decstr) //判断是否.txt文件的路径;
        if (
          typeof valuesArr[j] == 'object' &&
          valuesArr[j].funstr &&
          valuesArr[j].funstr == 'GTAFunWait'
        ) {
          try {
            getTime = valuesArr[j].decstr
            getTime = eval(getTime) * 1000
            newArr = valuesArr.splice(j + 1)
            setTimeout(() => {
              this.printSetInterval(newArr, partIndex)
            }, getTime)
            break
          } catch (e) {
            console.log(e)
          }
        } else if (
          // 显示音频
          valuesArr[j].funstr == 'GTAFunAudio' &&
          valuesArr[j].decstr
        ) {
          this.exchangeAudio(valuesArr[j].decstr, partIndex)
          this.$forceUpdate()
        } else if (
          // 显示文本的解析
          valuesArr[j].decstr &&
          valuesArr[j].funstr == 'GTAPrint' &&
          !hasImg &&
          !hasCamera &&
          typeof valuesArr[j].decstr == 'string'
        ) {
          partIndex = eval(partIndex)
          if (!hasTextFile) {
            var str = valuesArr[j].decstr
            //格式化字符串
            str = this.$util.foramtStr(str)
            // 储存文本内容
            this.partNumArr[partIndex - 1].msgRunResult.push(str)
          } else {
            // 储存文本路径
            let textUrl = valuesArr[j].decstr
            this.getTextFromUrl(partIndex, textUrl)

            // this.partNumArr[partIndex - 1].textUrl.push(valuesArr[j].decstr)
          }
          this.$forceUpdate()
        } else if (
          // 摄像头中进行人物识别的解析
          valuesArr &&
          valuesArr.length &&
          valuesArr[j] &&
          valuesArr[j].funstr == 'GTAPrint' &&
          valuesArr[j].decstr &&
          valuesArr[j].decstr.result &&
          !valuesArr[j].url
        ) {
          let aiFunc = valuesArr[j].function
          let result = valuesArr[j].decstr.result
          if (result) {
            //判断显示哪些算法
            this.getAiFunc(aiFunc, result, partIndex)
          }
          this.partNumArr[partIndex - 1].result = result //储存人物识别积木的数据
          this.$forceUpdate()
        } else if (
          // 图片中进行人物识别的解析
          valuesArr &&
          valuesArr.length &&
          valuesArr[j] &&
          valuesArr[j].funstr == 'GTAPrint' &&
          valuesArr[j].decstr &&
          valuesArr[j].url
        ) {
          let aiFunc = valuesArr[j].function
          let attr = valuesArr[j].attr //某个积木功能
          let decstr = valuesArr[j].decstr
          let result = decstr.result
          var error_msg, imgAiVal

          try {
            error_msg = valuesArr[j].decstr.error_msg
          } catch (e) {
            console.log(e)
          }
          if (decstr) {
            //某个积木功能在返回结果进行匹配并返回值
            imgAiVal = this.getImgAiFunc(aiFunc, attr, decstr)
          } else if (error_msg) {
            imgAiVal = '该模型仅支持小于2M的图片'
          }
          //显示结果补充的文本
          var imgAiText = this.getImgAiText(attr)
          imgAiVal = imgAiText + ': ' + imgAiVal
          this.partNumArr[partIndex - 1].msgRunResult.push(imgAiVal) //文本显示数组储存人物识别的结果
          this.$forceUpdate()
        } else if (
          //GTAPrint方法 显示图片的解析
          valuesArr[j] &&
          valuesArr[j].funstr == 'GTAPrint' &&
          hasImg
        ) {
          try {
            let src = valuesArr[j].decstr
            let imgObj = {}
            src = src.replace(reg_6, '').replace(reg_7, '')
            // 处理为代理
            src = this.photoBaseUrl + src.split(this.fileBaseUrl)[1];
            imgObj.src = src
            imgObj.size = 1
            this.partNumArr[partIndex - 1].imgArr.push(imgObj)
            this.partNumArr[partIndex - 1].imgLength = this.partNumArr[
              partIndex - 1
            ].imgArr.length
            this.partNumArr[partIndex - 1].src = src
            this.$forceUpdate()
          } catch (e) {
            console.log(e)
          }
        } else if (
          //GTASetImageSize方法 显示图片的解析-能依据图片大小解析
          valuesArr[j] &&
          valuesArr[j].funstr == 'GTASetImageSize'
        ) {
          // try {
          let src = valuesArr[j].urlstr
          let size = Number(valuesArr[j].result.size / 100)
          src = src.replace(reg_6, '').replace(reg_7, '')
          let imgObj = {}
          imgObj.src = src
          imgObj.size = size
          this.partNumArr[partIndex - 1].src = src
          this.partNumArr[partIndex - 1].imgArr.push(imgObj)
          this.partNumArr[partIndex - 1].imgLength = this.partNumArr[
            partIndex - 1
          ].imgArr.length
          this.partNumArr[partIndex - 1].size = size
          this.$forceUpdate()
          // } catch (e) {}
        }
      } //for end
    },

    //解析音频功能
    exchangeAudio(item, partIndex) {
      let audioObj = {},
        match_quot = /"|'/g,
        match_brace = /\{|\}/g,
        match_http = /(?<=url:).*/,
        match_url = /url/
      item = item.replace(/\s/g, '')
      item = item.replace(match_brace, '').replace(match_quot, '')
      let tempArr = item.split(',')
      tempArr.forEach((str) => {
        if (/url/.test(str)) {
          let url = str.match(match_http)[0]
          audioObj.url = url
        } else {
          let itemArr = str.split(':')
          itemArr[1] = itemArr[1].replace(match_quot, '')
          audioObj[itemArr[0]] = itemArr[1]
        }
      })
      this.audioList[partIndex - 1] = {
        ...this.audioList[partIndex - 1],
        ...audioObj,
      }
      this.audioList.forEach(item => {
        item.url = this.photoBaseUrl + '/aishixun' + item.url.split('/aishixun')[1];
      });
    },

    //判断调用哪些算法
    getAiFunc(aiFunc, result, partIndex) {
      let self = this
      switch (aiFunc) {
        case 'GTAFunGetFace':
          showFaceApiDom(self, result, partIndex)
          break
        case 'GTAFunGetHand':
          showHandApiDom(self, result, partIndex)
          break
        case 'GTAFunGetBody':
          showBodyApiDom(self, result, partIndex)
          break
        default:
          break
      }
    },
    //过滤器，在返回结果中匹配某个积木功能的值
    getImgAiFunc(aiFunc, attr, decstr) {
      let aiVal
      let result = decstr.result

      switch (aiFunc) {
        case 'GTAFunGetFace':
          //峰驼式命名，转下划线命名规则
          attr = this.toLine(attr)
          var faceListObj = result.face_list[0]
          aiVal = faceListObj[attr]
          if (typeof aiVal == 'object' && aiVal.type) {
            let text = aiVal.type
            if (aiVal.probability) {
              text =
                text + '，置信度：' + (aiVal.probability * 100).toFixed(0) + '%'
            }
            aiVal = text
          }
          break
        case 'GTAFunGetHand':
          var num = 0
          for (var i = 0, len = result.length; i < len; i++) {
            if (result[i] && result[i].classname) {
              var classname = result[i].classname
            }
            if (classname == attr) {
              aiVal = classname
            }
            if (classname == 'Face') {
              num++
            }
          } //for end
          if (attr == 'Count') {
            //人体流量统计
            aiVal = num
          }
          if (!aiVal) aiVal = '识别失败'
          break
        case 'GTAFunGetBody':
          break
        case 'GTAFunGetBodyNum':
          attr = this.toLine(attr)
          let result_num
          if (decstr.result_num || decstr.result_num == 0) {
            result_num = decstr.result_num
          }
          aiVal = result_num
          break
        default:
          break
      }
      if (!attr) {
        attr = '识别失败'
      }
      return aiVal
    },
    // 驼峰转换下划线
    toLine(name) {
      return name.replace(/([A-Z])/g, '_$1').toLowerCase()
    },
    //显示结果补充的文本
    getImgAiText(attr) {
      // attr=attr.toLowerCase();
      var text
      switch (attr) {
        case 'age':
          text = '年龄'
          break
        case 'gender':
          text = '性别'
          break
        case 'beauty':
          text = '颜值'
          break
        case 'faceShape':
          text = '脸型'
          break
        case 'expression':
          text = '表情'
          break
        case 'emotion':
          text = '情绪'
          break
        case 'race':
          text = '人种'
          break
        case 'Fist':
          text = '握拳'
          break
        case 'Congratulation':
          text = '作揖'
          break
        case 'Honour':
          text = '作别'
          break
        case 'Thumb_up':
          text = '点赞'
          break
        case 'Diss':
          text = 'Thumb_down'
          break
        case 'Rock':
          text = 'Rock'
          break
        case 'OK':
          text = 'OK'
          break
        case 'Count':
          text = '人流量'
          break
        default:
          text = '结果'
          break
      }
      return text
    },

    // 获取并解析无人小车积木信息
    getDriveInfo(codeText, partIndex) {
      var self = this,
        reg_drive = /GTAFunDrive/,
        reg_drive_url = /GTAFunDrive/,
        reg_equal = /=/,
        reg_1 = /\s|\(|\)|'|"/g,
        driveText,
        driveArr
      driveText = codeText.replace(reg_drive, '').replace(reg_1, '')
      driveArr = driveText.split('url=')
      console.log('driveArr', driveArr)
      if (/url\=/.test(driveText)) {
        let obj = {}
        obj.MediaFileUrl = driveArr[1]
        obj.partIndex = partIndex
        this.mediaArr[partIndex - 1] = {}
        this.mediaArr[partIndex - 1] = obj
        return '\n'
      } else {
        return codeText
      }
    },
    //获取标题积木的信息并修改
    getTitleInfo(str, partIndex) {
      str = str.replace('partName=', '').trim()
      var titleArr = eval(str), //字符串转为js对象
        index = eval(titleArr[0]),
        title = titleArr[1]
      if (index <= this.partNumTitleArr.length) {
        this.partNumTitleArr[index - 1] = title
      }
      // debugger;
    },

    exchangeColor() {
      util.getColor('#5490FF', 0.3)
    },
    // 获取新建积木的标志和脚本;
    getCreateBlockInfo(str, partIndex) {
      this.createBlockTextLength = str.length
      return str
    },

    // 分离创建积木的脚本
    splitCreateBlockCode() {
      const reg_create = /CREATEBLOCK\(/
      const { createBlockTextLength } = this
      let newText
      let codeTextResult = this.codeTextResult //被解析的代码
      let tempCodeText = this.codeTextResult //被解析的代码
      const reg_part = /PART/gi
      const splitIndex = codeTextResult.indexOf('CREATEBLOCK')
      // 存在创建积木标志时;去除新建积木标志的脚本
      if (reg_create.test(codeTextResult)) {
        newText = codeTextResult.substr(splitIndex, createBlockTextLength - 1)
        this.ifCreateBlock = true
      } else {
        this.ifCreateBlock = false
      }
      codeTextResult = codeTextResult.replace(newText, '')
      this.codeTextResult = codeTextResult //运行的python脚本

      // 把新建积木后面的脚本(某个功能的脚本)分离出来保存，后面用来表示新建积木的文本功能;
      if (reg_create.test(codeTextResult) !== -1) {
        tempCodeText = codeTextResult.substr(splitIndex, tempCodeText.length)

        // tempCodeText = tempCodeText.substr(
        //   createBlockTextLength,
        //   tempCodeText.length
        // ); //去掉插入
      }
      // tempCodeText 剪切去除分区标志part
      var partTextIndex = tempCodeText.indexOf('part')
      tempCodeText = tempCodeText.substring(0, partTextIndex)
      this.newBlockPythonCode = tempCodeText //保存新建的python脚本
    },

    // 对无人小车每个积木功能处理，并返回一行无人小车方法的代码
    getDriveText(partIndex) {
      var gtaFunDriveObj = this.gtaFunDriveArr[partIndex - 1],
        getDriveText,
        recording = gtaFunDriveObj.recording, //是否启动
        throttle = gtaFunDriveObj.throttle, //前进、后退
        speed = gtaFunDriveObj.speed, //速度
        angle = gtaFunDriveObj.angle, //角度
        url = gtaFunDriveObj.url //视频地址
      //speed 和throttle 要经过转换, angle的值要调试
      if (recording == 'true') {
        getDriveText =
          '\n' +
          '    GTAFunDrive(' +
          angle +
          ',' +
          throttle +
          ",'" +
          "user','" +
          recording +
          "')\n"
      } else {
        //暂停
        getDriveText =
          '\n' +
          '    GTAFunDrive(' +
          0 +
          ',' +
          0 +
          ",'" +
          "user','" +
          recording +
          "')\n"
      }
      return getDriveText
    },
    clearWorkspace() {
      // 清除积木编辑区域
      // this.$refs.blockly.clearWorkspace();
      // 清除运行结果区域
      this.runResult = {}
      this.runStasus = ''
      this.codeResult = []
      this.partNumArr = [{ imgArr: [] }]
      this.audioList = []
      this.partNumTitleArr = ['标题']
      this.mediaArr = []
      this.running = null
      this.runStasus = null
      this.partIndex = 1
      this.partNum = 1
      this.isMeida = null
      this.partWidth = null
      this.partHeight = null
      this.mediaWidth = null
      this.mediaHeight = null
      this.offsetWidth = null
      this.MediaOffsetTop = null
      this.MediaOffsetLeft = null
      this.$forceUpdate()
    },
    // 重绘
    sidebarSwitchHandle(val) {
      this.sidebarSwitch =
        val === 'codeRun' ? this.sidebarSwitch : !this.sidebarSwitch
      let switchObj = {
        sidebarSwitch: this.sidebarSwitch,
        type: 'codeRun',
      }
      bus.$emit('onSidebarSwitch', switchObj)
      this.$emit('sidebarSwitchHandle', switchObj)
    },
    // codeRunSwitchHandler(sidebarSwitch) {
    //   this.sidebarSwitch = sidebarSwitch
    // },
    // 切换指导书
    // switchGuideBook() {
    //   bus.$emit("guideBookResize");
    // },
    fullScreen() {
      // TODO: 全屏操作
      this.isFullScreen = !this.isFullScreen
      this.getHeightWidth(this.partNum) //重新计算宽高;
    },
    //确定建积木
    confirmNewBlock() {
      let newBlockPythonCode = this.newBlockPythonCode

      if (this.isPart) {
        this.$alert(
          '工作区有分区积木，新创建的积木只能匹配分区积木上面的积木脚本',
          '注意：',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              bus.$emit('confirmNewBlock', newBlockPythonCode)
            },
          }
        )
      } else {
        bus.$emit('confirmNewBlock', newBlockPythonCode)
      }
    },
  }, // methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
}
</script>
<style lang="scss" scoped>
@import './codeRun.scss';
</style>
<style lang="scss">
.el-message-box__wrapper {
  .el-message-box {
    .el-message-box__header {
      margin-top: 30px;
      color: rgba(103, 140, 255, 8);
      padding-bottom: 10px;
    }
    .el-message-box__content {
      text-align: left;
      padding-bottom: -10px !important;
    }
    .el-message-box__btns {
      padding-top: 0px !important;
      button:nth-child(1) {
        background: rgba(103, 140, 255, 1);
      }
    }
  }
}
</style>
